import pageheader from "../pageheader";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
import telematicsService from "../../api/telematics.service";

export default {
  name: "scheduled-reports",
  components: { pageheader },
  data() {
    return {
      input: {},
      search: "",
      isReportLoading: false,
      header: [
        { text: "Report Name", value: "reportName" },
        { text: "Company", value: "customerName" },
        { text: "Name", value: "name" },
        { text: "Format", value: "format" },
        { text: "Frequency", value: "frequency" },
        { text: "Emails", value: "emails" },
      ],
      reportDataList: [],
      pageNumber: 1,
      pageSize: 100,
      totalRecords: 0,
      totalRecordsCount: 0,
      countLables: [
        { name: "25", count: 25 },
        { name: "50", count: 50 },
        { name: "100", count: 100 },
        { name: "ALL", count: -1 },
      ],
    };
  },
  computed: {
    ...mapGetters(["roles"]),
    startPageCount() {
      if (this.totalRecordsCount === 0) return 0;
      if (this.pageSize == -1) return 1;
      return (this.pageNumber - 1) * this.pageSize + 1;
    },
    endPageCount() {
      if (this.pageSize == -1) return this.totalRecordsCount;
      const end = this.pageNumber * this.pageSize;
      return end > this.totalRecordsCount ? this.totalRecordsCount : end;
    },
  },
  mounted() {
    this.input = utils.getInputContent("scheduledReports", this.roles);
    this.readReportListFromAPI();
  },
  methods: {
    async readReportListFromAPI() {
      this.isReportLoading = true;
      try {
        const response = await telematicsService.getScheduledReports(
          this.pageNumber,
          this.pageSize
        );
        if (response && response.isSuccess) {
          const items = response.data || [];
          this.reportDataList = items.map((item) => ({
            ...item,
            emails: Array.isArray(item.emails)
              ? item.emails.join(", ")
              : item.emails,
          }));
          this.totalRecordsCount =
            response.totalRecords != null
              ? response.totalRecords
              : items.length;
          this.totalRecords =
            this.pageSize == -1
              ? 1
              : Math.ceil(this.totalRecordsCount / this.pageSize);
        } else {
          this.reportDataList = [];
          this.totalRecords = 0;
          this.totalRecordsCount = 0;
        }
      } catch (err) {
        this.reportDataList = [];
        this.totalRecords = 0;
        this.totalRecordsCount = 0;
        this.$toast.error("Unable to load scheduled reports");
        console.log(err);
      } finally {
        this.isReportLoading = false;
      }
    },
    pageChange() {
      this.pageNumber = 1;
      this.readReportListFromAPI();
    },
    getFirstPageData() {
      this.pageNumber = 1;
      this.readReportListFromAPI();
    },
    getLastPageData() {
      this.pageNumber = this.totalRecords;
      this.readReportListFromAPI();
    },
  },
};